import { ReactNode } from 'react';
import { LinkProps } from 'react-router-dom';

import { FormUsageContext } from 'components/Form/Form';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { StyledVersionedRouterLink } from 'components/Link/StyledVersionedRouterLink';

type Props = {
  formUsageContext: FormUsageContext;
  children: ReactNode;
  email: string;
  showForgotPasswordModal: (data: { email: string }) => void;
  getForgotPasswordUrl: (data: { email: string }) => LinkProps['to'];
};

export function LoginFormForgotPasswordLink({
  formUsageContext,
  children,
  email,
  showForgotPasswordModal,
  getForgotPasswordUrl,
}: Props) {
  if (formUsageContext === 'modal') {
    return (
      <StyledNativeLinkWithRef
        href="#"
        onClick={(e) => {
          e.preventDefault();
          showForgotPasswordModal({
            email,
          });
        }}
      >
        {children}
      </StyledNativeLinkWithRef>
    );
  }

  return (
    <StyledVersionedRouterLink
      to={getForgotPasswordUrl({
        email,
      })}
    >
      {children}
    </StyledVersionedRouterLink>
  );
}
